import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./app";
import { AppErrorBoundary } from "./components/app-error-boundary";
import { Providers } from "./providers";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode><AppErrorBoundary><BrowserRouter><Providers><App /></Providers></BrowserRouter></AppErrorBoundary></React.StrictMode>,
);
